import { isApp } from "./isApp";
import { isExperienceEditor } from "./isExperienceEditor";
import { isIOS } from "./isIOS";
import { openAppDownload, resolveDownloadUrl } from "./appDownload";
export function isPdfUrl(url: string): boolean {
	if (!url) {
		return false;
	}

	try {
		const { pathname } = new URL(url, window.location.href);
		return /\.pdf$/i.test(pathname);
	} catch {
		return /\.pdf$/i.test(url.split("?")[0] ?? url);
	}
}

function isModifiedClick(event: MouseEvent): boolean {
	return (
		event.metaKey ||
		event.ctrlKey ||
		event.shiftKey ||
		event.altKey ||
		event.button !== 0
	);
}

function getPdfUrlFromElement(element: HTMLElement): string | null {
	const url =
		element.getAttribute("data-pdf") ||
		element.getAttribute("data-pdf-url") ||
		element.getAttribute("href") ||
		"";

	return url && isPdfUrl(url) ? url : null;
}

export function initGlobalPdfDownloadHandler(): void {
	if (!isApp() || !isIOS() || isExperienceEditor) {
		return;
	}

	document.addEventListener("click", (event) => {
		if (event.defaultPrevented || isModifiedClick(event)) {
			return;
		}

		const element = (event.target as Element | null)?.closest<HTMLElement>(
			"a[href], [data-pdf-url]"
		);

		if (!element || element.closest(".button--pdf")) {
			return;
		}

		const pdfUrl = getPdfUrlFromElement(element);
		const resolved = pdfUrl ? resolveDownloadUrl(pdfUrl) : null;

		if (!resolved) {
			return;
		}

		event.preventDefault();
		openAppDownload(resolved);
	});
}
